import { userIndexOptions } from '$api-client/@tanstack/react-query.gen'
import { Role } from '$api-client/types.gen'
import { PersonSelectFilter, Strategy } from '$components'
import { useQuery } from '@tanstack/react-query'

type PersonFilterProps = {
  value: number[]
  onChange: (selectedIds: number[]) => void
}

export function PersonFilter({ value, onChange }: PersonFilterProps) {
  const { data: staff } = useQuery({
    ...userIndexOptions({
      query: {
        roles: [Role.GROOMER, Role.ADMIN, Role.SUPER_ADMIN],
      },
    }),
  })

  return (
    <PersonSelectFilter
      options={staff?.data ?? []}
      strategy={Strategy.State}
      value={value}
      onChange={onChange}
      size="sm"
    />
  )
}
